import React from 'react';
import { CompassIcon } from 'lucide-react';
import { EmptyState } from '../components/shared/EmptyState';
import { useBrand } from '../hooks/useBrand';
import { useDarkClasses } from '../hooks/useDarkClasses';

/** Catch-all for unknown URLs, so broken links never render a blank page. */
const NotFound = () => {
  const {
    content
  } = useBrand();
  const dk = useDarkClasses();
  return <div className={`w-full ${dk.page}`} data-id="element-11604" data-mp="1a4ajinsy56hl">
      <EmptyState icon={CompassIcon} title="Page not found" body="This page doesn't exist or has moved." action={{
      label: `Back to ${content.name}`,
      to: content.homePath
    }} className="min-h-[60vh]" data-id="element-11605" data-mp="1a3964cogk7wp" />
    </div>;
};
export default NotFound;